module.exports = __webpack_public_path__ + "img/bucket_driving.1122d8b4.svg";